import VapView from "../vap-view";
import { POINTER_VAP } from "@/const";
import Button from "@hfe/max-button";
import { createElement } from '@max/max';
export default function PointerVapContainer(props) {
    const { style: newStyle = {} } = props;
    return <Button style={{
        position: 'relative',
        overflow: 'visible'
    }} onPress={props.onPress}>
      <VapView {...POINTER_VAP} height={'112rpx'} width={'106rpx'} loop={true} style={Object.assign({ position: 'absolute', right: '-20rpx', bottom: '-30rpx', zIndex: 3 }, newStyle)}/>
      {props.children}
    </Button>;
}
